import { useState } from 'react';
import styles from './index.module.sass';
import { TabsBar } from '@/modules/common/components/tabs-bar';
import { OffersTab } from './components/offers-tab';
import { BuyerTab } from './components/buyer-tab';
import { DocsTab } from './components/docs-tab';

export const ContractDetailsWrap = () => {
  const [tabs, setTabs] = useState({
    activeTab: 0,
    tabs: [
      { label: 'позиции', id: 0, disabled: false },
      { label: 'покупатель', id: 1, disabled: false },
      { label: 'документы', id: 2, disabled: true },
    ],
  });
  return (
    <div className={styles.root}>
      <TabsBar
        activeItem={tabs.activeTab}
        tabs={tabs.tabs}
        setActiveTab={(id: number) => setTabs({ ...tabs, activeTab: id })}
      />
      <div className={styles.tabWrap}>
        {tabs.activeTab === 0 ? (
          <OffersTab />
        ) : tabs.activeTab === 1 ? (
          <BuyerTab/>
        ) : (
          <DocsTab />
        )}
      </div>
    </div>
  );
};
